import { getFormattedAddress } from '../../../../../../../../../Helpers/AddressHelper';

export const mapExistingAddressesToSelect = addresses => {
  return [
    ...addresses?.map(address => {
      return { key: address.id, value: address.id, displayName: getFormattedAddress(address) };
    }),
  ];
};
